import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function Popup({ items, show, langKey, callback }: any) {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang(langKey);
    const { t: s } = useLang('shared.product.popup');

    return (
        <>
            {show ? (
                <section className={`product-brief-guide-popup ${css['product-brief-guide-popup']}`}>
                    <div className="popup-content">
                        <h4 className="popup-header">
                            <span className="header-title">{s('title')}</span>
                            <svg
                                className="header-close"
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                onClick={callback}
                            >
                                <path d="M6 5L19 18M19 5L6 18" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </h4>
                        <div className="popup-main">
                            <ul className="popup-items">
                                {items?.map((item: any, k: number) => (
                                    <li className="popup-item" key={k}>
                                        <p className="item-title">{t(item?.question)}</p>
                                        <p className="item-desc">
                                            {t.rich(item?.answer, {
                                                s: () => <span className="s"></span>,
                                                a: (text: any) => (
                                                    <a
                                                        className="a"
                                                        target="_blank"
                                                        href={String(text) === `${locale}.ecoflow.com` ? `https://${text}` : text}
                                                        rel="noreferrer"
                                                    >
                                                        {text}
                                                    </a>
                                                ),
                                            })}
                                        </p>
                                        <div className="item-img"></div>
                                        {item?.img && (
                                            <div className="item-img">
                                                <EFPicture src={item?.img} alt={t(item?.question)} />
                                            </div>
                                        )}
                                    </li>
                                ))}
                            </ul>
                            <p className="popup-footer">
                                {s.rich('tip', {
                                    a: (text: any) => (
                                        <a className="a" target="_blank" href={text} rel="noreferrer">
                                            {text}
                                        </a>
                                    ),
                                    mail: (text: any) => (
                                        <a className="a" target="_blank" href={`mailto:${text}`} rel="noreferrer">
                                            {text}
                                        </a>
                                    ),
                                })}
                            </p>
                        </div>
                    </div>
                    {/* <style jsx global>
                        {`
                            .page-layout {
                                height: 100vh !important;
                                overflow: hidden;
                            }
                        `}
                    </style> */}
                </section>
            ) : null}
        </>
    );
}
